// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"93cce5b1","116":"a6e6fefc","133":"b63fbb18","285":"08bfb6c2","380":"4358a46c","521":"a94d223d","607":"2e59f05a","654":"1448aa83","761":"90849bab","810":"cf1c84a7","820":"7d85539c","895":"7888b54b","926":"72d49be2"}[chunkId] + ".chunk.js";
};